import { useCallback, useMemo, useState } from "react";
import { GridRowParams, GridRowsProp } from "@mui/x-data-grid";

import { useBillingHistory } from "../../../hooks/useBillingHistory";
import { Fields, TRow } from "../lib/types";

const PER_PAGE = 12; // Show invoice history in 12 months

export const useBillingHistoryFacade = () => {
  const [lastInvoiceId, setLastInvoiceId] = useState<string>();

  const { data, error, isLoading, hasMore, total } = useBillingHistory({
    lastInvoiceId,
    perPage: PER_PAGE,
  });

  const rows: GridRowsProp<TRow> = useMemo(
    () =>
      data.map((record) => ({
        [Fields.ID]: record.id,
        [Fields.PLAN]: {
          name: record.plan,
          invoiceNumber: record.number,
          invoiceUrl: record.invoiceUrl,
        },
        [Fields.AMOUNT]: {
          amount: record.amount,
          currency: record.currency,
        },
        [Fields.DATE]: record.createdAt,
        [Fields.STATUS]: record.status,
      })),
    [data],
  );

  const redirectToInvoice = useCallback(({ row }: GridRowParams<TRow>) => {
    const a = document.createElement("a");
    a.href = row.plan.invoiceUrl;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }, []);

  const loadMore = useCallback(() => {
    if (!hasMore) return;
    const lastRecordId = data.at(-1)?.id;
    if (!lastRecordId) return;
    setLastInvoiceId(lastRecordId);
  }, [data, hasMore]);

  return {
    rows,
    isLoading,
    error,
    loadMore,
    hasMore,
    total,
    redirectToInvoice,
  };
};
